/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workflow_SavedInputs */

const cs_workflow_saved = /** @type {(inputs: Workflow_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workflow uložen`)
};

const en_workflow_saved = /** @type {(inputs: Workflow_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workflow saved`)
};

/**
* | output |
* | --- |
* | "Workflow saved" |
*
* @param {Workflow_SavedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const workflow_saved = /** @type {((inputs?: Workflow_SavedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workflow_SavedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_workflow_saved(inputs)
	return cs_workflow_saved(inputs)
});